import DBModal from 'components/modal/modal';
import styles from './viewOrders.module.scss';
import {Form, Input, message} from 'antd';
import {useState} from 'react';
import plusIcon from 'images/plus-circle.png';
import trash from 'images/trash-can-outline.png';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {useMutation} from '@apollo/client';
import {SEND_EXPIRING_ORDERS} from 'graphql/mutations/stocks';
import {toast} from 'react-toastify';
import {ModalShell} from './ui/ModalShell';

const ManualTriggerEmail = ({isOpen, onClose}) => {
  const [emails, setEmails] = useState(['']);

  const handleDelete = id => {
    setEmails(emails?.filter((data, index) => index !== id));
  };

  const [sendExpiringOrderEmail, {loading}] = useMutation(SEND_EXPIRING_ORDERS);

  const handleSubmit = () => {
    if (!emails.length || emails.some(data => data == ''))
      return message.error('Some Required Fields are Missing');
    sendExpiringOrderEmail({
      variables: {
        emails: emails,
      },
    })
      .then(({data: sendExpiringOrderEmail}) => {
        if (sendExpiringOrderEmail.__typename === 'Error') {
          toast.error(
            `Something went wrong!!! - ${sendExpiringOrderEmail.message} `,
          );
        } else {
          toast.success('Sent to Emails Successfully');
          onClose();
          setEmails(['']);
        }
      })
      .catch(err => toast.error(`Something went wrong!! - ${err}`));
  };

  const onChangeEmailFields = (value, key) => {
    const values = [...emails];
    values[key] = value;
    setEmails(values);
  };

  return (
    <DBModal
      isOpen={isOpen}
      handleClose={() => onClose()}
      content={
        <Form onFinish={handleSubmit} layout="vertical">
          <ModalShell
            title="Email the expiring orders"
            subtitle="Sends the current expiring-order export to every address listed here."
            footer={<SubmitButton disabled={loading} label="Send export" />}>
            <div className={styles.emails}>
              {emails.map((data, index) => (
                <div className={styles.emailField} key={index}>
                  <Form.Item className={styles.emailWidth} label="Email">
                    <Input
                      type="email"
                      placeholder="name@dabafinance.com"
                      value={data}
                      onChange={e => onChangeEmailFields(e.target.value, index)}
                    />
                  </Form.Item>
                  {emails.length > 1 && (
                    <img
                      onClick={() => handleDelete(index)}
                      src={trash}
                      alt="Remove email"
                    />
                  )}
                </div>
              ))}
            </div>
            <div
              onClick={() => setEmails([...emails, ''])}
              className={styles.add}>
              <img src={plusIcon} alt="" />
              <h5>Add another email</h5>
            </div>
          </ModalShell>
        </Form>
      }
    />
  );
};

export default ManualTriggerEmail;
